import Web3 from "web3";
import magic from "./magic";

const RPC_URL = import.meta.env.VITE_RPC_URL as string;

/**
 * Get a Web3 instance with Magic's provider.
 * Use this ONLY for transactions that need the user's signature (.send()).
 * @returns Web3 instance connected to Magic's provider
 */
export function getWeb3(): Web3 {
  // Use the rpcProvider property from Magic
  return new Web3(magic.rpcProvider as any);
}

let readInstance: Web3 | null = null;

/**
 * Get a read-only Web3 instance for view calls (.call()), independent of Magic.
 * @returns Web3 instance connected to the direct RPC provider
 */
export function getReadWeb3(): Web3 {
  if (!readInstance) {
    // web3 v4 accepts a JSON-RPC URL string and builds an HTTP provider internally.
    // TODO: VITE_RPC_URL points at the free public Polygon endpoint, which can rate-limit
    // and have downtime. For better reliability, switch this to the Alchemy endpoint
    // (VITE_PROVIDER_ADDRESS / VITE_ALCHEMY_KEY) — same network and data, more robust.
    readInstance = new Web3(RPC_URL);
  }
  return readInstance;
}
